import React from "react";
import styles from "../Reference.scss";

export const ReferenceHeaderText = props => {
  const { fullName } = props;

  return (
    <React.Fragment>
      <h2 className={styles.title}>Employment Reference Check</h2>
      <div className={styles.subheading}>for {fullName}</div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/routes/admin/reference/components/Reference/ReferenceHeaderText.js